import styled from 'styled-components';

const ReportSummaryBody = styled.div`
  display: grid;
  grid-template-columns: minmax(min-content, calc(32vw - 2rem)) 1fr;
  grid-column-gap: ${(props): string => props.theme.spaces.xl};
  padding: 0 ${(props): string => props.theme.spaces.xl};
  overflow: auto;

  > * {
    padding: ${(props): string => props.theme.spaces.lg} 0;
    border-right: solid 0.1rem
      ${(props): string => props.theme.colors.heatherGray};

    &:last-child {
      border-right: none;
    }
  }
`;

export { ReportSummaryBody };
